export default {"src":"/_next/static/media/tracking.8b033572.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};